// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35PdB","toggle":"styles_toggle__1ZGSh","preview":"styles_preview__2fSvu"};